var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 159,
    viewBox: "0 0 183 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2231 154.273H59.6533",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0053 39.3861L54.4906 150.987C54.6604 153.003 55.6234 154.869 57.1681 156.175C58.7127 157.481 60.7127 158.121 62.7286 157.953L115.96 153.532C117.949 153.364 119.794 152.426 121.1 150.916C122.407 149.407 123.071 147.447 122.951 145.454L115.676 26.8872L56.3927 29.3574C49.7233 29.4068 44.4371 32.692 45.0053 39.3861Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0053 39.3861L54.4906 150.987C54.6604 153.003 55.6234 154.869 57.1681 156.175C58.7127 157.481 60.7127 158.121 62.7286 157.953L115.96 153.532C117.949 153.364 119.794 152.426 121.1 150.916C122.407 149.407 123.071 147.447 122.951 145.454L115.676 26.8872L56.3927 29.3574C49.7233 29.4068 44.4371 32.692 45.0053 39.3861Z",
    fill: "url(#paint0_linear_1285_139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0053 39.3861L54.4906 150.987C54.6604 153.003 55.6234 154.869 57.1681 156.175C58.7127 157.481 60.7127 158.121 62.7286 157.953L115.96 153.532C117.949 153.364 119.794 152.426 121.1 150.916C122.407 149.407 123.071 147.447 122.951 145.454L115.676 26.8872L56.3927 29.3574C49.7233 29.4068 44.4371 32.692 45.0053 39.3861Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9457 35.6808L59.431 147.282C59.6008 149.298 60.5638 151.164 62.1085 152.47C63.6531 153.776 65.6531 154.415 67.669 154.248L120.901 149.826C122.89 149.659 124.734 148.72 126.041 147.211C127.347 145.702 128.011 143.741 127.891 141.749L120.617 23.1819L61.3331 25.652C54.6637 25.7014 49.3776 28.9867 49.9457 35.6808Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0483 135.623L126.977 129.448",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6831 31.1852L99.1754 29.2214",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.066 146.269C104.203 146.269 106.747 143.726 106.747 140.588C106.747 137.45 104.203 134.906 101.066 134.906C97.9279 134.906 95.3843 137.45 95.3843 140.588C95.3843 143.726 97.9279 146.269 101.066 146.269Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3408 154.273H28.9616",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4032 37.4345L120.802 33.7293L120.185 23.2312L58.7009 26.0472C51.2164 26.4671 49.1681 31.5432 50.4032 37.4345Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.539 130.065L50.4028 37.4346L59.0483 135.005L111.539 130.065Z",
    fill: "#DBFFF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8058 74.4868L98.5707 59.6659L122.037 59.0484L123.272 73.2517L99.8058 74.4868Z",
    fill: "#DBFFF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66.7922L6.26139 116.825L67.4346 110.736L83.8363 120.086V108.945L88.8755 108.414L84.3551 58.3813L1 66.1623",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 66.7922L6.26139 116.825L67.4346 110.736L83.8363 120.086V108.945L88.8755 108.414L84.3551 58.3813L1 66.1623",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8706 86.4548L20.7611 106.006L72.6959 67.9534L25.2815 95.0756L16.8706 86.4548Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8706 86.4548L20.7611 106.006L72.6959 67.9534L25.2815 95.0756L16.8706 86.4548Z",
    fill: "url(#paint1_linear_1285_139)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8706 86.4548L20.7611 106.006L72.6959 67.9534L25.2815 95.0756L16.8706 86.4548Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1758 59.4313L93.7168 8.55865L178.221 1L182 51.4527L120.617 58.3815L106.117 69.3119L105.586 59.0732L99.1758 59.4313Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.873 29.0608L115.973 48.612L168.39 9.81836L119.913 38.1262L111.873 28.3568",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.873 29.0608L115.973 48.612L168.39 9.81836L119.913 38.1262L111.873 28.3568",
    fill: "url(#paint2_linear_1285_139)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.873 29.0608L115.973 48.612L168.39 9.81836L119.913 38.1262L111.873 28.3568",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1285_139",
    x1: 55.5041,
    y1: 109.187,
    x2: 135.33,
    y2: 128.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1285_139",
    x1: 24.4146,
    y1: 91.8428,
    x2: 69.4527,
    y2: 118.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1285_139",
    x1: 119.51,
    y1: 34.173,
    x2: 165.267,
    y2: 60.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer 2.879ede5ef05ef7ab69b474dcb3db71c2.svg";
export { ForwardRef as ReactComponent };